module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu5mxKOzY.3605d18.woff2";